import apiPrakasak from "../../api/apiPrakasak";

//&--------Get all edit requests----------------
export const getAllEditRequests = async (requestStatus) => {
  return await apiPrakasak.get(`/getParentsFeedbackByStatus/${requestStatus}`);
};

export const updateStudentFeedback = async (body) => {
  return await apiPrakasak.put("updateStudentsFeedback", body);
};
